import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminRequest } from '../../utils/adminRequest';

function AdminMembershipSettings() {
  const [config, setConfig] = useState({ priceYuan: '399', quota_count: 6, expiry_months: 6 });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const fetchConfig = async () => {
    try {
      const res = await adminRequest({ url: '/api/admin/membership-config', method: 'GET' });
      const c = res.data || {};
      setConfig({
        priceYuan: String(c.priceYuan ?? (c.price ? c.price / 100 : 399)),
        quota_count: c.quota_count ?? 6,
        expiry_months: c.expiry_months ?? 6
      });
    } catch (err) {
      if (err.response?.status === 401) navigate('/admin');
      else alert(err.response?.data?.error || '获取配置失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchConfig(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await adminRequest({
        url: '/api/admin/membership-config',
        method: 'PUT',
        data: {
          price: parseFloat(config.priceYuan) || 399,
          quota_count: parseInt(config.quota_count, 10) || 6,
          expiry_months: parseInt(config.expiry_months, 10) || 6
        }
      });
      alert('保存成功');
      fetchConfig();
    } catch (err) {
      alert(err.response?.data?.error || '保存失败');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div>加载中...</div>;

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>会员配置</h2>
      <form
        onSubmit={handleSubmit}
        style={{
          background: '#fff',
          borderRadius: 12,
          padding: 24,
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          maxWidth: 480
        }}
      >
        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', marginBottom: 8, fontWeight: 600 }}>价格（元）</label>
          <input
            type="number"
            min="0"
            step="1"
            value={config.priceYuan}
            onChange={(e) => setConfig({ ...config, priceYuan: e.target.value })}
            style={{
              width: '100%',
              padding: '10px 12px',
              border: '1px solid #ddd',
              borderRadius: 8,
              fontSize: 16
            }}
          />
        </div>
        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', marginBottom: 8, fontWeight: 600 }}>牵线名额数</label>
          <input
            type="number"
            min="1"
            max="99"
            value={config.quota_count}
            onChange={(e) => setConfig({ ...config, quota_count: e.target.value })}
            style={{
              width: '100%',
              padding: '10px 12px',
              border: '1px solid #ddd',
              borderRadius: 8,
              fontSize: 16
            }}
          />
        </div>
        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', marginBottom: 8, fontWeight: 600 }}>有效期（月）</label>
          <input
            type="number"
            min="1"
            max="120"
            value={config.expiry_months}
            onChange={(e) => setConfig({ ...config, expiry_months: e.target.value })}
            style={{
              width: '100%',
              padding: '10px 12px',
              border: '1px solid #ddd',
              borderRadius: 8,
              fontSize: 16
            }}
          />
        </div>
        <button
          type="submit"
          disabled={saving}
          style={{
            padding: '12px 24px',
            background: '#6366f1',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            fontSize: 16,
            fontWeight: 600,
            cursor: saving ? 'not-allowed' : 'pointer'
          }}
        >
          {saving ? '保存中...' : '保存'}
        </button>
      </form>
    </div>
  );
}

export default AdminMembershipSettings;
